import {Component} from '@angular/core';
import {UserService} from '../../services/user.service';

@Component({
    selector: 'app-nav',
    templateUrl: './nav.component.html',
    styleUrls: ['./nav.component.scss']
})
export class NavComponent {
    links = [
        {
            title: 'Nástěnka',
            href: '/dashboard',
            icon: 'dashboard',
            adminOnly: false
        },
        {
            title: 'Zápůjčky',
            href: '/contracts',
            icon: 'assignment',
            adminOnly: true
        },
        {
            title: 'Doklady',
            href: '/documents',
            icon: 'payments',
            adminOnly: true,
            accountant: true
        },
        {
            title: 'Inventář',
            href: '/products',
            icon: 'local_cafe',
            adminOnly: true
        },
        {
            title: 'Objednatelé',
            href: '/customers',
            icon: 'contacts',
            adminOnly: true
        },
        {
            title: 'Uživatelé',
            href: '/users',
            icon: 'supervisor_account',
            adminOnly: true
        },
        {
            title: 'Obrátkovost',
            href: '/revenue',
            icon: 'money',
            adminOnly: true
        },
        {
            title: 'Doprava',
            href: '/transport',
            icon: 'local_shipping',
            adminOnly: true
        },
        {
            title: 'Agenda',
            href: '/agenda',
            icon: 'event',
            adminOnly: true
        },
        {
            title: 'Opakovaná doprava',
            href: '/transport-repeat',
            icon: 'update',
            adminOnly: true
        },
        {
            title: 'Statistika dopravy',
            href: '/transport-stats',
            icon: 'trending_up',
            adminOnly: true
        }
    ];


    constructor(public userService: UserService) {
    }
}



// WEBPACK FOOTER //
// /app/src/AppModule/NavComponent/nav.component.ts